gsap.registerPlugin(ScrollTrigger);

let bgChangeTriggers = []; // массив только для этих триггеров

window.bgChangeAnimation = function bgChangeAnimation() {
  const body = document.querySelector('body');
  const bodyBg = document.querySelector('.body-bg');
  const elements = document.querySelectorAll('[data-sec-bg-change]');

  // убиваем старые триггеры перед созданием новых
  bgChangeTriggers.forEach((t) => t.kill());
  bgChangeTriggers = [];

  const isOnlyDark = !document.querySelectorAll('[data-sec-bg-change-light]');

  elements.forEach((element) => {
    const isLight = element.hasAttribute('data-sec-bg-change-light');
    const isDark = element.hasAttribute('data-sec-bg-change-dark');

    const next = element.nextElementSibling;

    if (next) {
      const currentIsDark = element.hasAttribute('data-sec-bg-change-dark');
      const currentIsLight = element.hasAttribute('data-sec-bg-change-light');
      const nextIsDark = next.hasAttribute('data-sec-bg-change-dark');
      const nextIsLight = next.hasAttribute('data-sec-bg-change-light');

      if ((currentIsDark && nextIsDark) || (currentIsLight && nextIsLight)) {
        element.classList.add('is-next-same-bg');
      }
    }

    const trigger = ScrollTrigger.create({
      trigger: element,
      start: 'top 50%',
      end: 'bottom 50%',
      onToggle: (self) => {
        if (self.isActive) {
          elements.forEach((el) => {
            el.classList.remove('is-bg-changes', 'is-next-bg-changes');
          });

          element.classList.add('is-bg-changes');
          if (element.previousElementSibling) {
            element.previousElementSibling.classList.add('is-next-bg-changes');
          }

          if (isLight && !isOnlyDark) {
            bodyBg.classList.remove('is-bg-dark');
            bodyBg.classList.add('is-bg-light');
            body.classList.remove('is-bg-dark');
            body.classList.add('is-bg-light');

            document.documentElement.style.setProperty(
              '--mf-cursor-bg-actual',
              `${getComputedStyle(element)
                .getPropertyValue('--cl-black')
                .trim()}`
            );
          } else if (isDark) {
            bodyBg.classList.remove('is-bg-light');
            bodyBg.classList.add('is-bg-dark');
            body.classList.remove('is-bg-light');
            body.classList.add('is-bg-dark');

            document.documentElement.style.setProperty(
              '--mf-cursor-bg-actual',
              `${getComputedStyle(element)
                .getPropertyValue('--cl-white')
                .trim()}`
            );
          }

          if (element.classList.contains('latest-works-sec-wr')) {
            bodyBg.classList.remove('is-worked-full-video-bg');
            body.classList.remove('is-worked-full-video-bg');
          }
        }
      },
    });

    bgChangeTriggers.push(trigger);
  });

  ScrollTrigger.refresh();
};

window.reinitBgChangeAnimation = function reinitBgChangeAnimation() {
  bgChangeAnimation();
};

if (!document.querySelector('.bold-loader-new')) {
  bgChangeAnimation();
}
